import React, { Component } from 'react'
import Divider from 'material-ui/Divider'
import Paper from 'material-ui/Paper'
import { List, ListItem } from 'material-ui/List'
import { Tab, Tabs } from 'material-ui/Tabs'
import RatingBar from '../components/RatingBar'
import { getRatingValues } from '../helpers/risks'
import { areas, likelihoods, consequences } from '../config/constants'
import { pageLoaded } from './utils'
import { riskItemLabel } from '../style/inlines'
import '../style/screens/risk-details.css'

class TabTemplate extends Component {
  render() {
    if (!this.props.selected) {
      return null
    }

    return this.props.children
  }
}

export default class RiskRegister extends Component {
  get styles() {
    return {
      root: {
        flex: '1 1 100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      },
      container: {
        flex: '1 1 100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
      }
    }
  }

  componentDidMount() {
    pageLoaded(this.props.risks.child(this.props.match.params.key).val().title)
  }

  render() {
    const child = this.props.risks.child(this.props.match.params.key)
    const risk = {
      ...child.val(),
      created: new Date(child.val().created),
      key: child.key
    }

    const detailsTab = (
      <Tab label='Details'>
        <div style={{ margin: '16px' }}>
          <div className='risk-detail-content-block'>
            <div className='row'>
              <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                <div className='risk-detail-content'>
                  <span>Title</span>
                  <p>{risk.title}</p>
                </div>
              </div>
              <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                <div className='risk-detail-content'>
                  <span>Owner</span>
                  <p>{this.props.users.child(risk.owner).val().name}</p>
                </div>
              </div>
              <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                <div className='risk-detail-content'>
                  <span>Created</span>
                  <p>{risk.created.toDateString()}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='risk-detail-content-block'>
            <div className='risk-detail-content'>
              <span>Description</span>
              {risk.description.split(`\n\n`).map((para, count) => <p key={count}>{para}</p>)}
            </div>
          </div>
          <div className='risk-detail-content-block'>
            <div className='risk-detail-content'>
              <span>Impact</span>
              {risk.impact.split(`\n\n`).map((para, count) => <p key={count}>{para}</p>)}
            </div>
          </div>
        </div>
      </Tab>
    )

    const ratingsTab = (
      <Tab label='Ratings'>
        <div>
          <div style={{ margin: '16px' }}>
            <span className='risk-detail-title'>Risk Ratings</span>
          </div>
          <List>
            <Divider />
            {risk.ratings.sort((b, a) => a.likelihood * a.consequence - b.likelihood * b.consequence).map((rating, index) => {
              const ratingValues = getRatingValues(rating.likelihood * rating.consequence)
              let divider;

              if (index !== risk.ratings.length - 1) {
                divider = <Divider />
              }

              return (
                <div key={index}>
                  <ListItem>
                    <div className='row' style={{ marginBottom: '5px', textAlign: 'center' }}>
                      <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                        <label {...riskItemLabel}>Area</label>
                        {areas[rating.impact]}
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                        <label {...riskItemLabel}>Likelihood</label>
                        {likelihoods[rating.likelihood].short} ({rating.likelihood})
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
                        <label {...riskItemLabel}>Consequence</label>
                        {consequences[rating.consequence].short} ({rating.consequence})
                      </div>
                    </div>
                    <RatingBar scale={true} rating={ratingValues} />
                    <div className='risk-detail-content' style={{ marginTop: '5px' }}>
                      <span>Rating description</span>
                      <p>{rating.description}</p>
                    </div>
                  </ListItem>
                  {divider}
                </div>
              )
            })}
          </List>
        </div>
      </Tab>
    )

    const actionsTab = (
      <Tab label='Actions'>
        <div style={{ margin: '16px' }}>
          <span className='risk-detail-title'>Risk Actions</span>
          The title of the risk is {risk.title}
        </div>
      </Tab>
    )

    return (
      <div>
        <Paper zDepth={2}>
          <Tabs
            style={this.styles.root}
            contentContainerStyle={this.styles.container}
            tabTemplate={TabTemplate}
          >
            {detailsTab}
            {ratingsTab}
            {actionsTab}
          </Tabs>
        </Paper>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/RiskDetails.js